import { useState, useEffect, useCallback } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import {
    fetchParamPOSSettings,
    upsertParamPOSSettings,
    deleteParamPOSSettings
} from "../../../api/requests/company-requests";

export const useParamPaymentSettings = (companyId) => {
    const [loading, setLoading] = useState(false);
    const [hasSettings, setHasSettings] = useState(false);
    const [settingsId, setSettingsId] = useState(null);

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            companyId: companyId || "",
            clientCode: "",
            clientUsername: "",
            clientPassword: "",
            guid: "",
            testMode: false,
            allowedIp: ""
        },
        validationSchema: Yup.object({
            companyId: Yup.string().required("Gerekli"),
            clientCode: Yup.string().required("Müşteri Kodu gerekli"),
            clientUsername: Yup.string().required("Kullanıcı adı gerekli"),
            clientPassword: Yup.string().required("Şifre gerekli"),
            guid: Yup.string().required("GUID gerekli")
        }),
        onSubmit: async (values) => {
            setLoading(true);
            try {
                const payload = {
                    companyId: values.companyId,
                    clientCode: values.clientCode,
                    clientUsername: values.clientUsername,
                    clientPassword: values.clientPassword,
                    guid: values.guid,
                    testMode: values.testMode,
                    allowedIp: values.allowedIp
                };

                const res = await upsertParamPOSSettings(payload);
                if (res?.success || res?.data) {
                    setHasSettings(true);
                    if (res?.data?.id) setSettingsId(res.data.id);
                    toast.success("Param POS ayarları güncellendi");
                }
            } catch (error) {
                toast.error("Param ayarları kaydedilirken hata oluştu");
            } finally {
                setLoading(false);
            }
        }
    });

    useEffect(() => {
        if (!companyId) return;

        const loadSettings = async () => {
            try {
                const res = await fetchParamPOSSettings(companyId);

                if (res?.data) {
                    setHasSettings(true);
                    setSettingsId(res.data.id ?? null);
                    formik.setValues({
                        companyId,
                        clientCode: res.data.clientCode ?? "",
                        clientUsername: res.data.clientUsername ?? "",
                        clientPassword: res.data.clientPassword ?? "",
                        guid: res.data.guid ?? "",
                        testMode: res.data.testMode ?? false,
                        allowedIp: res.data.allowedIp ?? ""
                    });
                } else {
                    setHasSettings(false);
                    setSettingsId(null);
                }
            } catch (error) {
                console.error("Param ayarları yüklenemedi", error);
                setHasSettings(false);
                setSettingsId(null);
            }
        };

        loadSettings();
    }, [companyId]);

    // Bağlantıyı kaldır: backend'deki kaydı siler ama girilen form bilgilerini
    // olduğu gibi bırakır (tekrar bağlanmak isterse yeniden yazmasın diye).
    const disconnect = useCallback(async () => {
        // Henüz kaydedilmemiş (yerel) bağlantı → sadece bağlı durumunu düşür.
        if (!settingsId) {
            setHasSettings(false);
            return true;
        }
        try {
            const res = await deleteParamPOSSettings(settingsId);
            if (res?.statusCode === 200 || res?.data === true) {
                setHasSettings(false);
                setSettingsId(null);
                return true;
            }
            return false;
        } catch (error) {
            console.error("Param bağlantısı kaldırılamadı", error);
            return false;
        }
    }, [settingsId]);

    return { formik, loading, hasSettings, disconnect };
};